// import { useEffect } from 'react';

// const useObjectSelection = (canvas, setSelectedAnnIndex) => {
//   useEffect(() => {
//     if (!canvas) return;

//     const onSelection = (o) => {
//       if (o.target) {
//         setSelectedAnnIndex(o.target.data?.annIndex ?? o.target.data?.polyIndex ?? -1);
//       }
//     };

//     const onCleared = () => setSelectedAnnIndex(-1);

//     canvas.on('selection:created', onSelection);
//     canvas.on('selection:updated', onSelection);
//     canvas.on('selection:cleared', onCleared);

//     return () => {
//       canvas.off('selection:created');
//       canvas.off('selection:updated');
//       canvas.off('selection:cleared');
//     };
//   }, [canvas, setSelectedAnnIndex]);
// };

// export default useObjectSelection;



import { useEffect } from 'react';

const useObjectSelection = (canvas, setSelectedAnnIndex,setCurrentClassId) => {
  useEffect(() => {
    if (!canvas) return;

    const onSelection = (e) => {
      const target = e.target || (e.selected && e.selected[0]) || null;
      if (target) {
        setSelectedAnnIndex(target.data?.annIndex ?? target.data?.polyIndex ?? -1);
        if (target.classData?.id) {
          setCurrentClassId(target.classData.id);
        }
      }
    };

    const onCleared = () => setSelectedAnnIndex(-1);

    canvas.on('selection:created', onSelection);
    canvas.on('selection:updated', onSelection);
    canvas.on('selection:cleared', onCleared);

    return () => {
      // remove the exact same handlers
      canvas.off('selection:created', onSelection);
      canvas.off('selection:updated', onSelection);
      canvas.off('selection:cleared', onCleared);
    };
  }, [canvas, setSelectedAnnIndex, setCurrentClassId]);
};

export default useObjectSelection;
